import Programa from '../../components/Programa/Programa'
import { Fragment, useCallback, useEffect, useState } from 'react'
import { metodoPrograma } from '../../components/api'
import {
  Box,
  Button,
  Checkbox,
  CircularProgress,
  Grid,
  Alert,
} from '@mui/material'
import Typography from '@mui/material/Typography'
import Stepper from '@mui/material/Stepper'
import Step from '@mui/material/Step'
import StepLabel from '@mui/material/StepLabel'
import { FaRegCheckCircle } from 'react-icons/fa'

const CtrlControleTermoAceiteFramework = () => {
  const [lista, setLista] = useState([])
  const [activeStep, setActiveStep] = useState(0)
  const [aceiteSteps, setAceiteSteps] = useState({})
  const [loadingNext, setLoadingNext] = useState(false)

  const handleAcessaProgramaPrincipal = () => {
    metodoPrograma('getProgramaDefault', {}).then((res) => {
      if (res.status && res.programa) {
        window.location.href = res.programa
      }
    })
  }

  const handleNext = () => {
    setActiveStep((prev) => prev + 1)
    window.scrollTo({ top: 0, behavior: 'smooth' })
  }

  const handleCheckboxChange = (step, checked, idTermoAceite) => {
    setLoadingNext(true)
    metodoPrograma('aceitarTermo', { idTermoAceite }).then((res) => {
      setLoadingNext(false)
      if (res.status) {
        setAceiteSteps((prev) => ({
          ...prev,
          [step]: checked,
        }))
      }
    })
  }

  const getList = useCallback(() => {
    metodoPrograma('lista', {}).then((res) => {
      if (res.status) {
        const aceiteInicial = {}
        res.lista.forEach((item, index) => {
          aceiteInicial[index] = !!item[5]
        })
        setAceiteSteps(aceiteInicial)
        setLista(res.lista)
      }
    })
  }, [])

  useEffect(() => {
    getList()
  }, [getList])

  const aceiteAtual = aceiteSteps[activeStep] ?? !!lista?.[activeStep]?.[5]

  return (
    <Programa codigo="CtrlControleTermoAceiteFramework">
      <Grid container spacing={2}>
        {lista?.length > 0 && (
          <Grid container spacing={2}>
            <Grid item xs={12} style={{ padding: 50 }}>
              <Box sx={{ width: '100%' }}>
                {activeStep === lista.length ? (
                  <Grid
                    item
                    xs={12}
                    style={{
                      display: 'flex',
                      flexDirection: 'column',
                      alignItems: 'center',
                      justifyContent: 'center',
                      textAlign: 'center',
                      gap: 20,
                      padding: 50,
                    }}
                  >
                    <Typography sx={{ mt: 2, mb: 1 }} variant="h6">
                      Todos os termos foram aceitos!
                    </Typography>

                    <FaRegCheckCircle
                      style={{ color: 'green', fontSize: 100, marginTop: 20 }}
                    />

                    <Button
                      fullWidth
                      onClick={handleAcessaProgramaPrincipal}
                      variant="contained"
                      color="primary"
                      style={{ maxWidth: 400, marginTop: 20 }}
                    >
                      Clique aqui para acessar o sistema
                    </Button>
                  </Grid>
                ) : (
                  <>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                        justifyContent: 'center',
                        textAlign: 'center',
                        gap: 20,
                        padding: 50,
                        marginBottom: 20,
                      }}
                    >
                      <Alert severity="warning">
                        Para continuar utilizando o sistema, é necessário
                        aceitar as políticas e termos que regem o uso da
                        plataforma.
                        <br />
                        <br />
                        Esses documentos descrevem as regras de funcionamento,
                        responsabilidades do usuário e como seus dados são
                        coletados e utilizados.
                        <br />
                        <br />
                        Leia atentamente cada termo e marque a opção de aceite
                        para prosseguir.
                      </Alert>
                    </Grid>
                    <Stepper activeStep={activeStep} alternativeLabel>
                      {lista.map((line, index) => (
                        <Step key={index}>
                          <StepLabel>{line[1]}</StepLabel>
                        </Step>
                      ))}
                    </Stepper>
                    <Grid container spacing={2}>
                      <Grid
                        item
                        xs={12}
                        style={{
                          padding: 50,
                          whiteSpace: 'pre-wrap',
                          borderRadius: 5,
                          marginTop: 35,
                          backgroundColor: '#f2f2f2',
                        }}
                      >
                        {lista?.[activeStep]?.[2]}
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          padding: 50,
                          whiteSpace: 'pre-wrap',
                          backgroundColor: '#e3e3e3',
                          display: 'flex',
                          justifyContent: 'flex-end',
                          alignItems: 'center',
                        }}
                      >
                        {loadingNext && (
                          <CircularProgress size={20} color="inherit" />
                        )}
                        <Checkbox
                          checked={aceiteAtual}
                          onChange={(e) =>
                            handleCheckboxChange(
                              activeStep,
                              e.target.checked,
                              lista?.[activeStep]?.[0],
                            )
                          }
                        />
                        <span>
                          Li e estou de acordo com {lista?.[activeStep]?.[1]}
                        </span>
                      </Grid>
                      <Grid
                        item
                        xs={12}
                        style={{
                          display: 'flex',
                          justifyContent: 'flex-end',
                        }}
                      >
                        <Button
                          fullWidth
                          onClick={handleNext}
                          disabled={!aceiteAtual}
                          variant="contained"
                          color="primary"
                        >
                          {activeStep === lista.length - 1
                            ? 'Finalizar'
                            : 'Próximo'}
                        </Button>
                      </Grid>
                    </Grid>
                  </>
                )}
              </Box>
            </Grid>
          </Grid>
        )}
      </Grid>
    </Programa>
  )
}

export default CtrlControleTermoAceiteFramework
